/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { DeploymentTemplateRequestBody } from '@modules/cloud-api/v1/types'
import withRouter from '@modules/routing/withRouter'

import { createDeploymentTemplate } from '@/actions/topology/deploymentTemplates'
import { fetchInstanceConfigurations } from '@/actions/topology/instanceConfigurations'
import { fetchInstanceTypes } from '@/actions/topology/fetchInstanceTypes'
import {
  fetchInstanceConfigurationsRequest,
  createDeploymentTemplateRequest,
} from '@/reducers/asyncRequests/registry'
import { getInstanceConfigurations } from '@/reducers/instanceConfigurations'
import { getInstanceTypes } from '@/reducers/instanceTypes'

import DeploymentTemplateCreate from './DeploymentTemplateCreate'

import type { StateProps, DispatchProps, ConsumerProps } from './types'
import type { ThunkDispatch, ReduxState } from '@/types/redux'

const mapStateToProps = (
  state: ReduxState,
  {
    router: {
      params: { regionId },
    },
  },
): StateProps => ({
  regionId,
  instanceTypes: getInstanceTypes(state, regionId),
  instanceConfigurations: getInstanceConfigurations(state, regionId),
  fetchInstanceConfigurationsRequest: fetchInstanceConfigurationsRequest(state, regionId),
  createDeploymentTemplateRequest: createDeploymentTemplateRequest(state, regionId),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  {
    router: {
      params: { regionId },
    },
  },
) => ({
  fetchInstanceTypes: () => dispatch(fetchInstanceTypes(regionId)),
  fetchInstanceConfigurations: () =>
    dispatch(fetchInstanceConfigurations(regionId, { showMaxZones: true })),
  createDeploymentTemplate: (deploymentTemplate: DeploymentTemplateRequestBody) =>
    dispatch(createDeploymentTemplate(regionId, deploymentTemplate)),
})

export default withRouter(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(DeploymentTemplateCreate),
)
